import { ROLES } from "~/shared.types";
import { useUserStore } from "./useUserStore";

export const useIsPatientRole = () => {
  const role = useUserStore((state) => state.role);
  return role === null || role === ROLES.USER.value;
};
